import { render, staticRenderFns } from "./permitTree.vue?vue&type=template&id=39384233&scoped=true"
import script from "./permitTree.vue?vue&type=script&lang=js"
export * from "./permitTree.vue?vue&type=script&lang=js"
import style0 from "./permitTree.vue?vue&type=style&index=0&id=39384233&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39384233",
  null
  
)

export default component.exports